// @flow

import React from 'react';
import PropTypes from 'prop-types';

import Alert from '@material-ui/lab/Alert';

import './style.css';

type Props = {
    children: any
};

function Info(props: Props) {
    const { children } = props;

    return (
        <Alert severity="info" variant="outlined" className="alert-info">
            {children}
        </Alert>
    );
}

Info.propTypes = {
    children: PropTypes.any.isRequired
};

export default Info;
